import { inject } from "fw";
import { createFrom } from "fw-model";
import { Manager } from "./manager";
import {
    TransferPlannerRouterDetectionSummary,
    TransferPlannerRouterDetectionSummarySearchResult
} from "models/transfer-planner/transfer-planner-detection-summary";

@inject
export class TransferPlannerRepository {
    constructor(private manager: Manager) {}

    public async listDetectionSummaries(
        filter: string,
        search: string = null,
        sort: string = null,
        previousPageToken: string = null,
        nextPageToken: string = null,
        fieldsPaths: string = null,
        aggs: string = null,
        aggregationsOnly: boolean = false,
        pageSize: number = 20
    ): Promise<TransferPlannerRouterDetectionSummarySearchResult> {
        const response = await this.manager.get<TransferPlannerRouterDetectionSummarySearchResult>("transfer-planner/detection-summary", {
            filter,
            search,
            sort,
            pageSize,
            previousPageToken,
            nextPageToken,
            aggs,
            fieldsPaths,
            aggregationsOnly
        });

        return createFrom(TransferPlannerRouterDetectionSummarySearchResult, response.body);
    }

    public async getDetectionSummaryById(detectionSummaryId: string): Promise<TransferPlannerRouterDetectionSummary> {
        const res = await this.manager.get<TransferPlannerRouterDetectionSummary>(`transfer-planner/detection-summary/${detectionSummaryId}`);
        return createFrom(TransferPlannerRouterDetectionSummary, res.body);
    }
}
